import { FTL_WEB_APP_API } from 'app/commons/constants/env.const'
import apiClient from 'app/commons/helpers/api/api'

import api from '../commons/helpers/api/index'

const coreApi = {
  getHotlineCurrentCustomer: (params = {}) => api.get(`${FTL_WEB_APP_API}/api/v3/freshchat/hotline_info`, params),
  updateFreshChatCustomer: (param: any) => api.put(`${FTL_WEB_APP_API}/api/v3/freshchat/customer`, param),
  postJoinCustomerChatChanel: (data: any) =>
    api.post(`${FTL_WEB_APP_API}/api/v3/chat/customers/member`, '', { booking_id: data }),
  getTwilioChatToken: (deviceID: any) => {
    const options = {
      headers: {
        'Device-Id': deviceID,
      },
    }
    return api.get(`${FTL_WEB_APP_API}/api/v3/chat/customers/token`, '', options)
  },
  getPopupArea: (params = {}) => api.get(`${FTL_WEB_APP_API}/api/v3/popups/area`, params),
  updateCustomerSetting: (param: any) => api.put(`${FTL_WEB_APP_API}/api/v3/settings/customers`, param),
  savedContacts: (params = {}) => {
    const query = {
      contact_type: 'normal',
      'only[]': ['id', 'location_name', 'name', 'phone', 'address'],
      ...params,
    }

    return api.get(`${FTL_WEB_APP_API}/api/v3/contacts/search`, query)
  },
  getContact: (id: any) => api.get(`${FTL_WEB_APP_API}/api/v3/contacts/${id}`, { id }),
  postContact: (body: any) => api.post(`${FTL_WEB_APP_API}/api/v3/contacts`, '', body),
  putContact: (id: any, body: any) => api.put(`${FTL_WEB_APP_API}/api/v3/contacts/${id}`, '', body),
  deleteContact: (id: any) => api.delete(`${FTL_WEB_APP_API}/api/v3/contacts/${id}`),
  trackDevice: (deviceID: string, deviceToken: string) =>
    apiClient.get(`${FTL_WEB_APP_API}/api/v3/settings/customers`, {
      headers: {
        'Fcm-Token': deviceToken,
        'Device-Id': deviceID,
      },
    }),
}

export default coreApi
